import { useState } from "react";
import ux1 from "../../common/images/ux-1.png";
import ux2 from "../../common/images/ux-2.png";
import web1 from "../../common/images/web-1.png";
import web2 from "../../common/images/web-2.png";
import { Link } from "react-router-dom";

import android1 from "../../common/images/android-1.png";
import iot1 from "../../common/images/iot-1.png";
import iot2 from "../../common/images/iot-2.png";
import custom1 from "../../common/images/custom-1.png";
import other from "../../common/images/other.png";
import crm_1 from "../../common/images/home-crm-1.png";
import pos_1 from "../../common/images/home-pos-1.png";
import pos_2 from "../../common/images/home-pos-2.png";
import crm_2 from "../../common/images/home-crm-2.png";

const services = [
  { id: "uiux", title: "UI/UX" },
  { id: "web-dev", title: "Web Development" },
  { id: "android", title: "Mobile App Development" },
  { id: "software", title: "Custom Software Development" },
  { id: "pos", title: "POS Solutions" },
  { id: "crm", title: "CRM Development" },
];

export default function ServicesSection() {
  const [activeTab, setActiveTab] = useState("web-dev");

  return (
    <div className="max-w-[1280px] mx-auto md:px-10  grid md:grid-cols-3">
      <div className="md:border-r-2 md:px-0 px-5 md:py-10 py-5">
        <h2 className="md:text-4xl text-2xl font-medium md:pb-5 pb-2 md:pl-5">
          Our Services
        </h2>
        <div className="grid grid-cols-1 small:gap-5 gap-0">
          {services.map((service) => (
            <button
              key={service.id}
              className={`block w-full text-left md:text-2xl text-sm py-5  md:px-4  transition ${
                activeTab === service.id
                  ? "text-webOranage border-b-[1px] border-webOranage px-2 font-bold"
                  : "text-[#B5B5B5] border-b-[1px] border-gray-300 font-medium hover:text-webOranage"
              }`}
              onClick={() => setActiveTab(service.id)}
            >
              {service.title}
            </button>
          ))}
        </div>
      </div>

      <div className="md:col-span-2 bg-slate-100  px-5 md:py-10 py-5">
        {activeTab === "web-dev" && (
          <div>
            <h2 className="md:text-3xl text-2xl font-bold">Web Development</h2>
            <p className="text-gray-600 mt-2">
              Our web development services include building scalable, secure,
              and high-performance websites using modern frameworks and best
              practices.
            </p>

            <div className="grid md:grid-cols-2 gap-5 mt-6">
              <div className="">
                <img
                  src={web1}
                  alt="Service"
                  className="size-full object-fill border-[1px] border-solid border-slate-400 small:h-[150px] h-[170px]"
                />
              </div>

              <div className="border-[1px] border-solid border-slate-400  p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">Frontend Development</h3>
                <p className="text-gray-600 text-[13px]">
                  We use React, Vue.js, and Angular to develop dynamic and
                  interactive UIs. Our approach includes component-based
                  architecture, state management (Redux, Vuex), and SSR for
                  performance optimization.
                </p>
                <Link to="/website-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>

              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">Backend Development</h3>
                <p className="text-gray-600 text-[13px]">
                  Our backend solutions use Node.js, Python (Django/Flask), PHP
                  (Laravel), and .NET Core to build RESTful and GraphQL APIs. We
                  implement microservices architecture for scalability and cloud
                  integration.
                </p>
                <Link to="/website-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="">
                <img
                  src={web2}
                  alt="Service"
                  className="size-full border-[1px] border-solid border-slate-400 object-fill small:h-[150px] h-[170px]"
                />
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">Full-Stack Solutions</h3>
                <p className="text-gray-600 text-[13px]">
                  Combining frontend and backend expertise, we develop complete
                  web applications using MERN, MEVN, and LAMP stacks. Our DevOps
                  practices ensure CI/CD pipelines and automated deployments.
                </p>
                <Link to="/website-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">Web Security & Performance</h3>
                <p className="text-gray-600 text-[13px]">
                  We implement security using OWASP best practices, JWT
                  authentication, OAuth, and SSL encryption. Performance is
                  optimized with lazy loading, caching (Redis, CDN), and
                  minification. These strategies ensure robust security and
                  efficient app performance.
                </p>
                <Link to="/website-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
            </div>
          </div>
        )}

        {activeTab === "uiux" && (
          <div>
            <h2 className="md:text-3xl text-2xl  font-bold">UI/UX Design</h2>
            <p className="text-gray-600 mt-2">
              We specialize in crafting user-centric designs that enhance
              usability, accessibility, and overall user satisfaction. Our UI/UX
              services focus on wireframing, prototyping, usability testing, and
              interaction design to create seamless digital experiences.
            </p>

            <div className="grid md:grid-cols-2 gap-5 mt-6">
              <div className="size-full">
                <img
                  src={ux1}
                  alt="Service"
                  className="size-full object-fill small:h-[170px] h-[170px]"
                />
              </div>

              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[170px] h-[170px] bg-white">
                <h3 className="font-bold">
                  User Interface <span className="text-webOranage">(UI)</span>
                </h3>
                <p className="text-gray-600 text-[13px]">
                  Designing visually appealing and interactive interfaces using
                  modern design systems like Material Design and Human Interface
                  Guidelines (HIG). We ensure responsive layouts, adaptive color
                  schemes, and micro-interactions for an engaging experience.
                </p>
                <Link to="/uiux-designer" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[170px] h-[170px] bg-white">
                <h3 className="font-bold">
                  User Experience <span className="text-webOranage">(UX)</span>
                </h3>
                <p className="text-gray-600 text-[13px]">
                  Conducting in-depth user research, journey mapping, and
                  usability testing to optimize interactions. We enhance
                  conversion rates by focusing on accessibility (WCAG
                  compliance) and frictionless navigation.
                </p>
                <Link to="/uiux-designer" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[170px] h-[170px] bg-white">
                <h3 className="font-bold">
                  UI and UX
                  <span className="text-webOranage"> Design</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Combining UI and UX strategies to create high-fidelity
                  prototypes, interactive mockups, and pixel-perfect designs
                  using tools like Figma, Adobe XD, and Sketch. We align
                  business goals with user needs for an optimal digital
                  presence.
                </p>
                <Link to="/uiux-designer" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[170px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Interaction & Usability{" "}
                  <span className="text-webOranage">Testing </span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  We conduct A/B testing, heatmaps, and usability studies to
                  refine UI/UX designs for better engagement. Our approach
                  ensures minimal cognitive load, fast load times, and
                  mobile-first responsiveness.
                </p>
                <Link to="/uiux-designer" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="size-full">
                <img
                  src={ux2}
                  alt="Service"
                  className="size-full object-fill small:h-[170px] h-[170px]"
                />
              </div>
            </div>
          </div>
        )}

        {activeTab === "android" && (
          <div>
            <h2 className="md:text-3xl text-2xl  font-bold">
              Android Development
            </h2>
            <p className="text-gray-600 mt-2">
              We build high-performance, feature-rich Android applications using
              the latest technologies and industry best practices.
            </p>
            <div className="grid md:grid-cols-2 gap-5 mt-6">
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Native Android
                  <span className="text-webOranage"> Development</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Developing robust native apps using Kotlin and Java, optimized
                  for Android 13+ with Jetpack components, MVVM architecture,
                  and Room Database for efficient data storage.
                </p>
                <Link to="/android-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Cross-Platform
                  <span className="text-webOranage"> Development</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  We build cross-platform applications using Flutter and React
                  Native, ensuring high performance and a native-like user
                  experience while reducing development time and costs.
                </p>
                <Link to="/android-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="">
                <img
                  src={android1}
                  alt="Service"
                  className="size-full object-fill small:h-[150px] h-[170px]"
                />
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  API & Database
                  <span className="text-webOranage"> Integration</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Our apps seamlessly connect with REST and GraphQL APIs, using
                  Firebase, SQLite, and PostgreSQL for real-time data
                  synchronization and cloud-based storage.
                </p>
                <Link to="/android-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  App Performance &{" "}
                  <span className="text-webOranage"> Security</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  We optimize app performance through multi-threading, memory
                  management, and efficient rendering with Compose UI. Security
                  measures include biometric authentication, AES encryption, and
                  Play Protect compliance.
                </p>
                <Link to="/android-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
            </div>
          </div>
        )}

        {activeTab === "software" && (
          <div>
            <h2 className="md:text-3xl text-2xl  font-bold">Custom Software</h2>
            <p className="text-gray-600 mt-2">
              We develop tailored software solutions to meet specific business
              needs, ensuring efficiency, automation, and scalability.
            </p>
            <div className="grid md:grid-cols-2 gap-5 mt-6">
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Enterprise Software{" "}
                  <span className="text-webOranage"> Development</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Creating scalable enterprise solutions using .NET, Java Spring
                  Boot, and Python Django. Our applications are optimized for
                  large-scale data processing, multi-user environments, and
                  secure access controls.
                </p>
                <Link to="/custom-software-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Cloud-Based
                  <span className="text-webOranage"> Solutions</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Developing cloud-native applications with AWS, Azure, and
                  Google Cloud, leveraging serverless computing, Kubernetes, and
                  containerization for cost efficiency and high availability.
                </p>
                <Link to="/custom-software-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>
              <div className="">
                <img
                  src={custom1}
                  alt="Service"
                  className="size-full object-fill small:h-[150px] h-[170px]"
                />
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  AI & Machine Learning
                  <span className="text-webOranage"> Integration</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  We leverage AI-driven solutions with TensorFlow, OpenCV, and
                  NLP models. These technologies enable automation, predictive
                  analytics, and advanced business intelligence. Our focus is on
                  improving efficiency and data-driven decision-making. AI
                  empowers smarter operations and insights.
                </p>
                <Link to="/custom-software-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Database Management &
                  <span className="text-webOranage"> Optimization</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  We work with MySQL, PostgreSQL, MongoDB, and NoSQL solutions
                  to design high-performance databases, implementing indexing,
                  partitioning, and sharding techniques.
                </p>
                <Link to="/custom-software-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>
            </div>
          </div>
        )}

        {activeTab === "pos" && (
          <div>
            <h2 className="md:text-3xl text-2xl  font-bold">POS Solutions</h2>
            <p className="text-gray-600 mt-2">
              At Binary Ops Pvt Ltd, we offer smart, reliable, and easy-to-use
              Point of Sale (POS) solutions designed to simplify your business
              operations and improve customer satisfaction.
            </p>
            <div className="grid md:grid-cols-2 gap-5 mt-6">
              <div className="border-[1px] border-solid border-slate-400">
                <img
                  src={pos_1}
                  alt="Service"
                  className="size-full object-fill small:h-[150px] h-[170px]"
                />
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Real-Time Inventory{" "}
                  <span className="text-webOranage"> Management </span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Monitor stock levels in real-time for complete inventory
                  visibility. This helps prevent both stockouts and
                  overstocking. Automated reordering streamlines the procurement
                  process. With real-time insights, you can optimize inventory
                  management.
                </p>
                <Link to="/point-of-sale-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>{" "}
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Sales and Performance{" "}
                  <span className="text-webOranage"> Reporting </span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Generate detailed, customizable reports to analyze sales
                  trends, employee performance, and customer behavior. This
                  enables you to identify growth opportunities and make
                  data-driven decisions to optimize business strategies and
                  increase profitability.
                </p>
                <Link to="/point-of-sale-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>{" "}
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Customer Relationship{" "}
                  <span className="text-webOranage"> Management (CRM) </span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Build comprehensive customer profiles to track their purchase
                  history. Use this information to personalize interactions and
                  improve engagement. Tailor experiences based on individual
                  preferences and behavior. Enhance satisfaction by offering
                  targeted communication.
                </p>
                <Link to="/point-of-sale-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>
              <div className="border-[1px] border-solid border-slate-400">
                <img
                  src={pos_2}
                  alt="Service"
                  className="size-full object-fill small:h-[150px] h-[170px]"
                />
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">
                  Employee <span className="text-webOranage"> Management</span>
                </h3>{" "}
                <p className="text-gray-600 text-[13px]">
                  Manage user roles, permissions, and employee performance to
                  control access to sensitive data. Streamline shift scheduling
                  and improve team collaboration for efficient operations and
                  resource utilization.
                </p>
                <Link to="/point-of-sale-development" className="self-end flex">
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>{" "}
              </div>
            </div>
          </div>
        )}
        {activeTab === "crm" && (
          <div>
            <h2 className="md:text-3xl text-2xl font-bold"> CRM Development</h2>
            <p className="text-gray-600 mt-2">
              At Binary Ops Pvt Ltd, we create custom CRM systems to strengthen
              customer relationships and streamline operations. Our tailored
              solutions help manage interactions, automate workflows, and gain
              valuable insights from a single platform.
            </p>

            <div className="grid md:grid-cols-2 gap-5 mt-6">
              <div className="">
                <img
                  src={crm_1}
                  alt="Service"
                  className="size-full object-fill small:h-[150px] h-[170px]"
                />
              </div>

              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold"> Sales Automation</h3>
                <p className="text-gray-600 text-[13px]">
                  Automate follow-ups, lead tracking, and pipeline management to
                  enhance sales efficiency. By reducing manual tasks, sales
                  teams can focus on closing deals faster. This leads to
                  improved conversion rates and smoother sales cycles.
                </p>
                <Link
                  to="/crm-development"
                  className="self-end flex"
                >
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>

              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">Task and Workflow Automation</h3>
                <p className="text-gray-600 text-[13px]">
                  Automate repetitive tasks like customer onboarding, order
                  processing, and service requests. This reduces manual effort
                  and human error, speeding up workflows. Teams can focus on
                  high-priority tasks, improving productivity and customer
                  satisfaction.
                </p>
                <Link
                  to="/crm-development"
                  className="self-end flex"
                >
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="">
                <img
                  src={crm_2}
                  alt="Service"
                  className="size-full object-fill small:h-[150px] h-[170px]"
                />
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">Custom Reporting & Analytics</h3>
                <p className="text-gray-600 text-[13px]">
                  Generate tailored reports and dashboards to analyze customer
                  behavior and sales trends. These insights help make informed
                  decisions and improve performance.
                </p>
                <Link
                  to="/crm-development"
                  className="self-end flex"
                >
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
              <div className="border-[1px] border-solid border-slate-400 p-4 flex flex-col relative small:h-[150px] h-[170px] bg-white">
                <h3 className="font-bold">Lead and Opportunity Management</h3>
                <p className="text-gray-600 text-[13px]">
                  Track leads through the sales funnel and assign them to teams
                  for effective follow-up. Real-time monitoring helps prioritize
                  high-value leads and ensures no opportunity is missed.
                </p>
                <Link
                  to="/crm-development"
                  className="self-end flex"
                >
                  <img
                    src={other}
                    alt="icon"
                    srcset=""
                    className="self-end text-gray-500 mt-auto absolute bottom-0 right-0 w-[40px] cursor-pointer "
                  />
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
